export default __webpack_public_path__ + "static/media/susie4.398f8dcc.jpg";